import React from "react";
import { Button, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";
import api from "./api";
import Cookies from "js-cookie";
import { loadingToast } from "../loading";

import "./index.less";

import docx from "./SQSMB.docx";

var timer;
class AttestationType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caType: "MOBILE", //认证方式
      second: 59,
      secondType: false,
      SQZS: "", // 授权书
      SQZSUrl: "",
      personalIdentity3Key: "",
      source: "", //来源{GR：个人，QY：企业}
      cerificationNo: "", //身份证号
      customerName: "", //姓名
      regCode: "", //企业信用代码
    };
  }

  componentWillReceiveProps(prevProps) {
    if (prevProps.fangShi !== this.state.caType) {
      this.setState(
        {
          caType: prevProps.fangShi,
        },
        () => {
          console.log(this.state.caType);
        }
      );
    }
  }

  // 获取验证码
  timerFN = () => {
    var shouji = document.getElementById("phoneNumber").value;
    if (!shouji || shouji.length < 11) {
      Toast.info("请填写正确的手机号码", 1);
      return;
    }
    if (!this.props.customerName || !this.props.cerificationNo) {
      Toast.info("请确认身份证已上传并且身份证号与姓名正确！", 1);
      return;
    }
    if (this.props.source === "QY" && !this.props.regCode) {
      Toast.info("请确认营业执照已上传并且社会信用代码/工商注册号正确！", 1);
      return;
    }
    clearInterval(timer);
    let _this = this;
    let url = "";
    if (localStorage.getItem("app_stoken")) {
      // url = api.h5.smsSendMessage + '?app_stoken=' + localStorage.getItem('app_stoken');
      url =
        api.h5.sendCertificateCode +
        "?app_stoken=" +
        localStorage.getItem("app_stoken");
    } else if (localStorage.getItem("sessionKey")) {
      // url = api.wechat.smsSendMessage + '?sessionKey=' + localStorage.getItem('sessionKey');
      url =
        api.wechat.sendCertificateCode +
        "?sessionKey=" +
        localStorage.getItem("sessionKey");
    } else {
      // url = api.h5.smsSendMessage + '?session_key=' + Cookies.get('session_key');
      url =
        api.h5.sendCertificateCode +
        "?session_key=" +
        Cookies.get("session_key");
    }
    post({
      url: url,
      data: {
        // smsType: 'ASPIRATION_CA',
        // mobileNumber: shouji
        account:
          this.props.source === "GR"
            ? shouji
            : shouji + "" + this.props.regCode, //用户账号	唯一标识（个人-手机号；企业-手机号+统一社会信用代码/工商注册号）
        name: this.props.customerName, //姓名
        identity: this.props.cerificationNo, //身份证号
        phoneNumber: shouji, //手机号
        userType: this.props.source === "GR" ? 1 : 2,
        plateformType: this.props.plateformType,
      },
    }).then(
      (res) => {
        console.log("验证码", res);
        if (res.result === "success") {
          _this.setState(
            {
              second: 59,
              secondType: true,
              personalIdentity3Key: res.data,
            },
            () => {
              let { second } = _this.state;
              timer = setInterval(function () {
                if (second < 0) {
                  clearInterval(timer);
                  _this.setState({
                    secondType: false,
                  });
                } else {
                  _this.setState({
                    second: second--,
                  });
                }
              }, 1000);
            }
          );
        } else {
          if (res.code == "-1") {
            href("/ACLogin");
            Toast.info("登录失效", 1);
          } else {
            Toast.info(res.msg, 1);
          }
        }
      },
      (res) => {
        if (res.code == "-1") {
          href("/ACLogin");
          Toast.info("登录失效", 1);
        } else {
          Toast.info(res.msg, 1);
        }
      }
    );
  };

  imgUpload = (file, FN) => {
    loadingToast("图片上传中...");
    let url = "";
    if (localStorage.getItem("app_stoken")) {
      url =
        api.attachment + "?app_stoken=" + localStorage.getItem("app_stoken");
    } else if (localStorage.getItem("sessionKey")) {
      url =
        api.attachment + "?sessionKey=" + localStorage.getItem("sessionKey");
    } else {
      url = api.attachment + "?session_key=" + Cookies.get("session_key");
    }
    post({
      url: url,
      headers: {
        "Content-Type": "multipart/form-data;",
      },
      data: {
        attachmenType: "IMGS_ALL",
        file: [file],
      },
    }).then(
      (res) => {
        if (res.result === "success" && res.data) {
          console.log(res.data);
          FN(res.data[0].attachmenturl);
        } else {
          if (res.code == "-1") {
            href("/ACLogin");
            Toast.info("登录失效", 1);
          } else {
            Toast.info(res.msg, 1);
          }
        }
      },
      (res) => {
        if (res.code == "-1") {
          href("/ACLogin");
          Toast.info("登录失效", 1);
        } else {
          Toast.info(res.msg, 1);
        }
      }
    );
  };

  // 授权书
  imgChange = () => {
    let _this = this;
    var reader = new FileReader();
    var SQZS = document.getElementById("SQZS").files;
    if (SQZS[0].size > 3145728) {
      //3*1024*1024 = 3145728
      Toast.info("授权书不能大于3M", 1);
      return;
    }
    reader.readAsDataURL(SQZS[0]);
    reader.onload = function () {
      console.log(this.result);
      _this.imgUpload(SQZS[0], (img) => {
        _this.setState(
          {
            SQZSUrl: img,
            SQZS: this.result.split("base64,")[1],
          },
          () => {
            Toast.hide();
            _this.onCancel();
          }
        );
      });
      // console.log(this.result)
      // _this.setState({
      //     SQZS: this.result
      // }, ()=>{
      //     _this.onCancel();
      // });
    };
  };

  onCancel = () => {
    let { caType, SQZS, SQZSUrl, personalIdentity3Key } = this.state;
    let { plateformType } = this.props;
    if (caType !== "AUTH") {
      if (caType === "PERSONAL") {
        this.props.onCancel("", "", caType, personalIdentity3Key);
      } else {
        this.props.onCancel(
          document.getElementById("phoneNumber").value,
          plateformType === "SSQ" ? document.getElementById("YZM").value : "",
          caType,
          personalIdentity3Key
        );
      }
    } else {
      this.props.onCancel(
        document.getElementById("phoneNumber").value,
        plateformType === "SSQ" ? document.getElementById("YZM").value : "",
        caType,
        personalIdentity3Key,
        SQZSUrl
      );
    }
  };

  render() {
    let { secondType, second } = this.state;
    let { selectSign, plateformType } = this.props;
    return (
      <div className="AttestationTypeBox">
        {this.state.caType !== "AUTH" ? (
          <div>
            {plateformType === "SSQ" ? (
              <div className="selectBox">
                <div
                  className={[
                    "SJH ",
                    this.state.caType === "MOBILE" ? "active" : "",
                  ].join(" ")}
                  onClick={() => {
                    this.setState(
                      {
                        caType: "MOBILE",
                      },
                      () => {
                        this.onCancel();
                      }
                    );
                  }}
                >
                  <i></i>
                  <div>
                    <div>
                      {selectSign ? <span>{selectSign}</span> : ""}
                      手机号认证
                    </div>
                  </div>
                </div>
                <div
                  className={[
                    "SL ",
                    this.state.caType === "PERSONAL" ? "active" : "",
                  ].join(" ")}
                  onClick={() => {
                    // Toast.info('暂不支持刷脸认证', 2);
                    this.setState(
                      {
                        caType: "PERSONAL",
                      },
                      () => {
                        this.onCancel();
                      }
                    );
                  }}
                >
                  <i></i>
                  <div>
                    <div>
                      {selectSign ? <span>{selectSign}</span> : ""}
                      刷脸认证
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.caType === "MOBILE" ? (
              <div className="numberBox">
                <div className="toastText">
                  *请确保该手机号是在运营商处实名购买，不支持虚拟电话卡，否则无法通过实名认证。
                </div>
                <div>
                  <label htmlFor="phoneNumber">
                    <span>{selectSign ? selectSign : ""}手机号</span>
                    <input
                      id="phoneNumber"
                      type="tel"
                      maxLength="11"
                      placeholder="请填写"
                      onChange={(e) => {
                        this.onCancel();
                      }}
                      onBlur={() => {
                        this.onCancel();
                      }}
                    />
                    {plateformType === "SSQ" ? (
                      secondType ? (
                        <div className="second secondText">{second}S</div>
                      ) : (
                        <div className="second" onClick={this.timerFN}>
                          获取验证码
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </label>
                  {plateformType === "SSQ" ? (
                    <label htmlFor="YZM">
                      <span>验证码</span>
                      <input
                        id="YZM"
                        type="number"
                        placeholder="请填写"
                        onChange={(e) => {
                          this.onCancel();
                        }}
                        onBlur={() => {
                          this.onCancel();
                        }}
                      />
                    </label>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>
            <div className="numberBox">
              <div className="toastText" style={{ color: "#f00" }}>
                *选择授权书认证，将以电子形式发送给法人进行认证。
              </div>
              <div className="toastText">
                *请确保该手机号是在运营商处实名购买，不支持虚拟电话卡，否则无法通过实名认证。
              </div>
              <div>
                <label htmlFor="phoneNumber">
                  <span>经办人手机号</span>
                  <input
                    id="phoneNumber"
                    type="tel"
                    maxLength="11"
                    placeholder="请填写"
                    onChange={(e) => {
                      this.onCancel();
                    }}
                    onBlur={() => {
                      this.onCancel();
                    }}
                  />
                  {plateformType === "SSQ" ? (
                    secondType ? (
                      <div className="second secondText">{second}S</div>
                    ) : (
                      <div className="second" onClick={this.timerFN}>
                        获取验证码
                      </div>
                    )
                  ) : (
                    ""
                  )}
                </label>
                {plateformType === "SSQ" ? (
                  <label htmlFor="YZM">
                    <span>验证码</span>
                    <input
                      id="YZM"
                      type="number"
                      placeholder="请填写"
                      onChange={(e) => {
                        this.onCancel();
                      }}
                      onBlur={() => {
                        this.onCancel();
                      }}
                    />
                  </label>
                ) : (
                  ""
                )}
                {plateformType === "SSQ" ? (
                  <div>
                    <span>授权书上传</span>
                    <div>
                      <label
                        htmlFor="SQZS"
                        style={{
                          backgroundImage: this.state.SQZS
                            ? "url(" + this.state.SQZSUrl + ")"
                            : "",
                          backgroundSize: "contain",
                        }}
                      >
                        <input
                          id="SQZS"
                          type="file"
                          accept="image/*"
                          onChange={() => {
                            this.imgChange();
                          }}
                        />
                      </label>
                      <div>
                        <a href={docx}>授权书下载</a>
                        <p>
                          下载授权书到本地后打印，加盖公章后牌照上传，支持上传图片格式：jpeg、jpg、png格式且大小不超过3M。
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AttestationType;



// WEBPACK FOOTER //
// ./src/authCertificate/modules/attestationType/index.js